import React from "react";
import style from "./index.module.scss";
import classNames from "classnames";
import { useNavigateQuestion } from "service/stores/Exercise/Statics";
import { htmlToPlain } from "utils/common";
import { BaseQuestionType, EndExerciseQuestion } from "service/exercise";

interface ListItemProps {
    index: number;
    data: EndExerciseQuestion;
    selected?: boolean;
}

export default function ListItem({ index, data, selected }: ListItemProps) {
    const { go } = useNavigateQuestion();

    function onClick() {
        window.scrollTo(0, 0);
        go(data.id);
    }

    return (
        <div
            className={classNames(style.root, selected ? style.selected : "")}
            onClick={onClick}>
            {index + 1}.
            <span className={style.info}>
                （{data.queTypeName}，{data.score}分）
            </span>
            {htmlToPlain(data.contentText)}
            {data.queTypeId < BaseQuestionType.Mixed &&
                data.queTypeId !== BaseQuestionType.Subjective && (
                    <span className={style.rate}>{data.accuracy}</span>
                )}
        </div>
    );
}
